import React from 'react'
import { Form, Field } from 'react-final-form'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { getFormErrorMessage } from '../utilities/FormHelpers'
import { ColorPicker } from 'primereact/colorpicker';
import { Checkbox } from 'primereact/checkbox';
/*
    props:
    values {}
    onSubmit (data)
*/
export const AssetDepartmentForm = (props) => {
	const validate = (formData) => {
		let errors = {};

		if(!formData.assetDepartmentName || formData.assetDepartmentName === "") {
			errors.assetDepartmentName = "Name required";
		}

		return errors;
	}

	return (
		<Form
			onSubmit={props.onSubmit}
			validate={validate}
			initialValues={props.values}
			render={({handleSubmit}) => (
				<form onSubmit={handleSubmit} className="master-form">
					<Field name="assetDepartmentName"
						render={({ input, meta }) => (
							<div>
								<span className="p-float-label">
									<InputText {...input}
										id="assetDepartmentName"
									/>
									<label htmlFor='assetDepartmentName'>Name:&nbsp;</label>
								</span>
								{getFormErrorMessage(meta)}
							</div>
						)}/>
					<Field name="assetDepartmentColor"
						render={({ input, meta }) => (
							<div>
								<span className="p-float-label">
									<ColorPicker {...input}
										id="assetDepartmentColor"
										style={{marginLeft: 50}}
									/>
									<label htmlFor='assetDepartmentColor'>Color:&nbsp;</label>
								</span>
								{getFormErrorMessage(meta)}
							</div>
						)}/>
					<Field type="checkbox"
						name="assetDepartmentDefault"
						render={({ input, meta }) => (
							<div>
								<span className="p-float-label">
									<Checkbox id="assetDepartmentDefault"
										{...input}
										style={{marginLeft: 120}}/>
									<label htmlFor='assetDepartmentDefault'>Show by default:&nbsp;</label>
								</span>
								{getFormErrorMessage(meta)}
							</div>
						)}/>
					<div className='submit-footer'>
						<Button type="submit" label="Submit" />
					</div>
				</form>
			)}
		/>
	);
}